import React from "react";
import styled from 'styled-components';

import {
	Paper, Typography, useMediaQuery,
} from "@mui/material";

const CardHome = (props) => {
	const {
		title, description, icon, url
	} = props;

  const matches = useMediaQuery('(min-width:45rem)');

	return (
		<PaperStyled
			key={title}
			style={{
				...styles.cardContainer,
				minWidth: matches ? '28rem' : '20rem',
			}}
			onClick={() => props.history.push(`/${url}`)}
		>
			<div style={styles.iconContainer}>
				<img src={icon} style={styles.image} />
			</div>
			<div style={styles.titleContainer}>
				<Typography style={styles.title}>{title}</Typography>
				<Typography style={styles.description}>{description}</Typography>
			</div>
		</PaperStyled>
  )
}

const PaperStyled = styled(Paper)`
  &:hover {
		box-shadow: -4px 3px 14px -4px #bbb !important;
		/* background-color: rgba(0,0,0,.02); */
	};
`;

const styles = {
	cardContainer: {
		flex: 1,
		display: 'flex',
		marginLeft: '1rem',
		marginBottom: '1rem',
		borderRadius: 20,
		overflow: 'hidden',
		cursor: 'pointer',
	},
	iconContainer: {
		backgroundColor: '#f6fafe',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '2rem',
		borderRadius: 20,
	},
	image: {
		width: '4.5rem',
	},
	title: {
		fontWeight: 'bold',
		fontSize: '1.25rem',
		marginBottom: '0.75rem',
	},
	description: {
		fontSize: '0.75rem',
	},
	titleContainer: {
		padding: '2rem',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
	}
}

export default CardHome;